import { createStore } from 'redux';

import simulation from '../reducers/simulation';

export default createStore(simulation);